import progressActions from '../actions/ProgressActions';

export const defaultState = {
    progressBarValue: 0,
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case progressActions.types.PROGRESS_PROGRESS_BAR_VALUE:
        return Object.assign({}, state, {
            progressBarValue: action.progressBarValue,
        });

    default:
        return state;
    }
}
